import {plotFftRatioFourDUnit} from "../utils/map_utils";
import FFTRatioFourDHT1 from "./FFTRatioFourDHT1";

class FFTRatioFourDT1 extends FFTRatioFourDHT1 {
    id = "fftRatio4dT1";
    label = "FFT Ratio 4D V T1";
    defaultVisible = this.props.tileViewerState[this.id];

    process = (v, xc, yc, margin, sizeOfMarker, countRed, countYellow, source, rescanThresh, rescanThresh2) => {
        let type = 'V';
        let {rescanThreshValue1, rescanThreshValue2} = this.props;
        plotFftRatioFourDUnit(v, this.props.slide, xc, yc, margin, sizeOfMarker, this.layer.getSource(),
            rescanThreshValue1, rescanThreshValue2, type);
        if (v["NORTH"]) {
            for (let crop = 0; crop < v["NORTH"].length; crop++) {
                if (v['NORTH'][crop] <= 500 + rescanThresh * 500)
                    countYellow += 1;
                if (v['NORTH'][crop] <= rescanThresh * 1000)
                    countRed += 1;
            }
        }
    }
}

export default FFTRatioFourDT1;
